import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type ShopUserProfileFeedbackDescriptionProps = {
  description: string;
  translatedDescription?: string;
};

const DESCRIPTION_PREVIEW_LENGTH = 160;

const ShopUserProfileFeedbackDescription = ({ description, translatedDescription }: ShopUserProfileFeedbackDescriptionProps) => {
  const { t } = useTranslation();
  const [isDescriptionExpanded, setDescriptionExpanded] = useState(false);
  const [showOriginalDescription, setShowOriginalDescription] = useState(false);
  const hasTranslatedDescription = Boolean(translatedDescription);
  const descriptionToShow = (hasTranslatedDescription && !showOriginalDescription ? translatedDescription : description) ?? '';

  const isDescriptionTruncated = useMemo(() => descriptionToShow.length > DESCRIPTION_PREVIEW_LENGTH, [descriptionToShow]);
  const visibleDescription = useMemo(() => {
    if (isDescriptionExpanded || !isDescriptionTruncated) {
      return descriptionToShow;
    }

    return `${descriptionToShow.slice(0, DESCRIPTION_PREVIEW_LENGTH)}...`;
  }, [descriptionToShow, isDescriptionExpanded, isDescriptionTruncated]);

  useEffect(() => {
    setDescriptionExpanded(false);
  }, [descriptionToShow]);

  return (
    <>
      <div className="shop-user-profile-feedback__description-wrapper">
        <p className="shop-user-profile-feedback__description">
          {visibleDescription}
          {isDescriptionTruncated && (
            <>
              {' '}
              <span
                className="shop-user-profile-feedback__description-toggle"
                role="button"
                tabIndex={0}
                onClick={() => setDescriptionExpanded((prev) => !prev)}
              >
                {isDescriptionExpanded ? t('components.page-shop.read-less') : t('components.page-shop.read-more')}
              </span>
            </>
          )}
        </p>
      </div>

      {hasTranslatedDescription && (
        <Grid container className="shop-user-profile-feedback__description-translation-notice">
          <p role="link" tabIndex={1} onClick={() => setShowOriginalDescription((prev) => !prev)}>
            {showOriginalDescription
              ? t('components.page-shop.shop-description-show-translated')
              : t('components.page-shop.shop-description-show-original')}
          </p>
        </Grid>
      )}
    </>
  );
};

export default ShopUserProfileFeedbackDescription;
